import { ConnectProto } from "@racoon/api";
import { getEnumValue } from "@racoon/lib";
import { normalizeJobTypeKey } from "~/shared/lib/container-group-job-types";

/** "JOB_TYPE_*" names priced by the container group's contract, which the group list preloads. */
export const contractJobTypes = (cg: ConnectProto.ContainerGroup | undefined): string[] => {
  const tariff = cg?.contract?.tariffRateByJobType ?? {};
  // Legacy keys ("MSW", "10") count too; a key the JobType enum lacks drops.
  return [...new Set(Object.keys(tariff).map(normalizeJobTypeKey))].filter(
    (key) => getEnumValue(ConnectProto.JobTypeSchema, key) !== undefined,
  );
};
